import React from 'react'
import styles from './LoaderPage.module.css'

export const LoaderPage = () => {
    return (
        <>
            <div className="loader_wrapper" style={{
                height: window.innerHeight - 100,
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "transparent",
                flexDirection: "column",
                justifyContent: "center"

            }}>
                {/* <img width="60px" src={"./images/dual_ring.svg"} alt="loader" style={{
                    borderRadius: "50%"
                }} /> */}
                {/* <LoadPanel visible={true} /> */}
            </div>
        </>
    )
}

export const LoaderApp = () => {
    return (
        <>
            <div style={{
                height: window.innerHeight - 100,
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "transparent",
                flexDirection: "column",
                justifyContent: "center"

            }}>
                <div className={styles.logoContainer}>
                    <img alt='logo' className={styles.logo} style={{ height: "120px" }} src="https://auth.1school.edu.vn/logo.png" />
                    <div className={styles.lightOverlay}></div>
                </div>

            </div>
        </>
    )
}

export default LoaderPage